import { SITE } from "@/config";

// Simple, editable content for the legal / info pages.
// Edit the copy freely — each section is just a heading + paragraphs.
export const STATIC_CONTENT = {
  contact: {
    title: "Contact",
    intro: "We're here to help. Reach out and we'll get back to you as soon as we can.",
    sections: [
      {
        heading: "Email",
        body: [`Write to us at ${SITE.contactEmail} and we'll respond within 1–2 business days.`],
      },
      {
        heading: "Before you buy",
        body: [
          "Happy to answer any questions about how the stand works, compatibility with your phones, or how we configure it for your Google review page.",
        ],
      },
    ],
  },
  shipping: {
    title: "Shipping",
    intro: "Every stand is configured for your business before it ships.",
    sections: [
      {
        heading: "Processing",
        body: [
          "Orders are configured and prepared within 2–3 business days. We connect your stand to your Google review page before dispatch.",
        ],
      },
      {
        heading: "Delivery",
        body: [
          "Flat-rate shipping is £4.99 per order. Delivery times vary by destination. You'll receive tracking details by email once your order is on its way.",
        ],
      },
    ],
  },
  returns: {
    title: "Returns",
    intro: "We want you to be happy with your Google Review Stand.",
    sections: [
      {
        heading: "Return window",
        body: [
          "If something isn't right, contact us within 14 days of delivery and we'll help arrange a return or replacement.",
        ],
      },
      {
        heading: "Condition",
        body: [
          "Returned items should be in their original condition. Because each stand is configured for a specific business, please reach out first so we can assist.",
        ],
      },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    intro: "We respect your privacy and only collect what we need to fulfil your order.",
    sections: [
      {
        heading: "Information we collect",
        body: [
          "We collect the details needed to process and ship your order, such as your name, address and the Google review link for your business.",
        ],
      },
      {
        heading: "Payments",
        body: [
          "Payments are processed securely by Stripe. We never store your full card details.",
        ],
      },
      {
        heading: "Contact",
        body: [`Questions about your data? Email ${SITE.contactEmail}.`],
      },
    ],
  },
  terms: {
    title: "Terms of Service",
    intro: "The essentials of buying and using your Tap Review stand.",
    sections: [
      {
        heading: "The product",
        body: [
          "The Google Review NFC Stand makes it easier for customers to reach your Google review page. It does not guarantee more reviews.",
        ],
      },
      {
        heading: "Requirements",
        body: [
          "An active Google Business Profile that accepts reviews is required. The stand works with modern NFC-compatible iPhone and Android devices.",
        ],
      },
      {
        heading: "Trademarks",
        body: [
          "Google is a trademark of Google LLC. Tap Review is not affiliated with, endorsed by, or sponsored by Google.",
        ],
      },
    ],
  },
};
